<script>
import moment from 'moment';
import { getVisitBookedForDate } from '@/util/helpers';
import SocialVisitsService from '@/services/SocialVisitsService';

export default {
  name: 'VisitorsPreviousSocialVisits',
  props: {
    visitorUserId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      previousVisits: [],
      columns: [
        {
          key: 'date',
          name: 'Date',
        },
        {
          key: 'prisonerNumber',
          label: `${this.$options.filters.term('prison', true)} Number`,
        },
        {
          key: 'actions',
          label: 'Actions',
        },
      ],
      previousVisitsTableData: [],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
    };
  },
  watch: {
    visitorUserId() {
      this.getPreviousVisits();
    },
  },
  mounted() {
    this.getPreviousVisits();
  },
  methods: {
    getVisitBookedForDate,
    getPreviousVisits() {
      this.loading = true;
      SocialVisitsService.getPreviousSocialVisits(this.visitorUserId).then(res => {
        this.previousVisits = res.data;
        this.totalRows = this.previousVisits.length;
        this.loading = false;
      }).catch(err => {
        console.error('Error getting users previous social visits', err, { visitorUserId: this.visitor.user_id });
        this.$toast.error('Error getting users previous social visits. Please check your connection and refresh the page.', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    pushDetailsPage(visit) {
      this.$store.dispatch('socialVisits/setVisit', visit);
      this.$router.push({ name: 'social-visit-details', params: { id: visit._id } });
    },
    getVisitBookedFor(visit) {
      return moment(getVisitBookedForDate(visit).bookedForDate).format('DD/MM/YYYY');
    },
  },
};
</script>

<template>
  <b-card>
    <b-card-title>
      Previous Social Visits
    </b-card-title>

    <section v-if="loading">
      <b-spinner variant="primary" label="Loading previous calls" />
    </section>

    <section v-else>
      <section v-if="previousVisits && previousVisits.length" class="previous-visits-table">
        <p><b>All Previous Social Visits</b></p>
        <b-table
          hover
          :fields="columns"
          :items="previousVisits"
          :current-page="currentPage"
          :per-page="perPage"
          :responsive="true"
        >
          <template #cell(date)="data">
            {{ getVisitBookedFor(data.item) }}
          </template>
          <template #cell(prisonerNumber)="data">
            {{ data.item.prisoner.prisoner_number }}
          </template>
          <template #cell(actions)="data">
            <b-btn variant="primary" class="btn btn-sm btn-primary" @click.prevent="pushDetailsPage(data.item)">
              <span class="fas fa-search" /> View
            </b-btn>
          </template>
        </b-table>
      </section>
      <div v-else>
        <p>Visitor has no previous social visits</p>
      </div>
    </section>
  </b-card>
</template>
